import * as React from 'react';
import FormTextBox, { FormTextBoxDataType } from 'src/components/controls/forms/redesign/FormTextbox';
import Button from 'src/components/controls/forms/redesign/FormButton';
import PropertyUtil from 'src/util/PropertyUtil';
import FormSelect from 'src/components/controls/forms/redesign/FormFilterSelect';
import * as _ from 'lodash';
import { FormApi } from 'final-form';
import './OwnerSearch.scss';
import PagedResultSet from 'src/models/common/PagedResultSet';
import State from 'src/models/State';
import { SelectItem } from 'src/models/common/SelectItem';
import MultiplePhoneNumber from './MultiplePhoneNumber';
import PhoneNumberType from 'src/models/PhoneNumberType';
import ZipCodeUtil from 'src/util/ZipCodeUtil';
import Prefixes from 'src/models/Prefixes';
import Suffixes from 'src/models/Suffixes';
import OwnerType from './OwnerType';
import { convertMartialStatusesToSelectList } from 'src/models/MaritalStatus';
import OwnerJointTenantOwner from 'src/models/tract_detail/add_ownership_revised/OwnerJointTenantOwner';
// import OwnerJointTenantOwner from 'src/models/tract_detail/add_ownership_revised/OwnerJointTenantOwner';

export interface IOwnerTypesFormProps {
    prev: () => void;
    next: () => void;
    getCityState: (zipCode: string) => void;
}

export type IOwnerTypesFormStateProps = {
    selectedOwnerType: OwnerType;
    form: FormApi;
    phoneNumberTypes: Array<PhoneNumberType>;
    states: PagedResultSet<State>;
};

type IOwnerTypesFormPageProps = IOwnerTypesFormProps & IOwnerTypesFormStateProps;

type OwnerTypesFormState = {
    tenantOwners: OwnerJointTenantOwner[];
};

class OwnerTypesForms extends React.Component<IOwnerTypesFormPageProps, OwnerTypesFormState> {
    constructor(props: IOwnerTypesFormPageProps) {
        super(props);
        this.state = {
            tenantOwners: [],
        };
    }

    jointTenantOwners = () => {
        return this.state.tenantOwners.map((owner, index) => {
            return (
                <div key={index} style={{ borderBottom: '1px solid grey' }}>
                    <div style={{ marginBottom: '0.5rem' }}>Owner #{index + 1}</div>
                    <div>
                        <FormTextBox
                            style={{ width: '10%' }}
                            name={`ownerJointTenant.tenantOwners[${index}].prefix`}
                            label="Prefix"
                            className="lh-fifth-width"
                        />

                        <FormTextBox
                            style={{ width: '25%' }}
                            name={`ownerJointTenant.tenantOwners[${index}].firstName`}
                            label="First Name"
                            className="lh-fifth-width"
                            isRequired={true}
                        />

                        <FormTextBox
                            style={{ width: '25%' }}
                            name={`ownerJointTenant.tenantOwners[${index}].lastName`}
                            label="Last Name"
                            className="lh-fifth-width"
                            isRequired={true}
                        />

                        <FormTextBox
                            style={{ width: '25%' }}
                            name={`ownerJointTenant.tenantOwners[${index}].middleName`}
                            label="Middle Name"
                            className="lh-fifth-width"
                        />

                        <FormTextBox
                            style={{ width: '10%' }}
                            name={`ownerJointTenant.tenantOwners[${index}].suffix`}
                            label="Suffix"
                            className="lh-fifth-width"
                        />
                    </div>

                    <div>
                        <FormTextBox
                            name={`ownerJointTenant.tenantOwners[${index}].addressLine1`}
                            label="Address Line 1"
                            className="lh-half-width"
                        />
                        <FormTextBox name={`ownerJointTenant.tenantOwners[${index}].addressLine2`} label="Address Line 2" className="lh-half-width" />
                    </div>

                    <div>
                        <FormTextBox
                            name={`ownerJointTenant.tenantOwners[${index}].city`}
                            label="City"
                            className="lh-eighth-width"
                        />
                        <FormTextBox
                            name={`ownerJointTenant.tenantOwners[${index}].state`}
                            label="State"
                            className="lh-eighth-width"
                        />
                        <FormTextBox
                            name={`ownerJointTenant.tenantOwners[${index}].zipCode`}
                            label="Zip Code"
                            className="lh-eighth-width"
                        />
                        <FormTextBox name={`ownerJointTenant.tenantOwners[${index}].email`} label="Email" className="lh-eighth-width" />
                        <FormTextBox name={`ownerJointTenant.tenantOwners[${index}].phone`} label="Phone" className="lh-eighth-width" />
                    </div>
                    {/* <div>

                        <FormTextBox
                            style={{ width: '28%' }}
                            name={`ownerJointTenant.tenantOwners[${index}].aka`}
                            label="Aka"
                            className="lh-fifth-width"
                        />
                    </div> */}
                </div>
            );
        });
    };

    addJointTenantOwner = () => {
        this.setState({
            tenantOwners: [...this.state.tenantOwners, new OwnerJointTenantOwner()],
        });
    };

    render() {
        const states = PropertyUtil.SafeGet(() => this.props.states.items);
        const selectStates = states ? states.map((state: State) => new SelectItem(state.id, state.abbreviation)) : new Array<SelectItem>();
        const selectJTStates = selectStates.map((state: SelectItem) => new SelectItem(state.name, state.name));

        return (
            <>
                {PropertyUtil.SafeGet(() => this.props.selectedOwnerType) === OwnerType.Individual && (
                    <>
                        <div className="selected-owner-type">
                            <div>
                                <FormSelect
                                    style={{ width: '8%' }}
                                    name="individualOwner.prefix"
                                    items={Prefixes}
                                    label="Prefix"
                                    className="lh-fifth-width"
                                />
                                <FormTextBox
                                    style={{ width: '28%' }}
                                    name="individualOwner.firstName"
                                    label="First Name"
                                    className="lh-fifth-width"
                                    isRequired={true}
                                />
                                <FormTextBox
                                    style={{ width: '28%' }}
                                    name="individualOwner.middleName"
                                    label="Middle Name"
                                    className="lh-fifth-width"
                                />
                                <FormTextBox
                                    style={{ width: '28%' }}
                                    name="individualOwner.lastName"
                                    label="Last Name"
                                    className="lh-fifth-width"
                                    isRequired={true}
                                />
                                <FormSelect
                                    style={{ width: '8%' }}
                                    name="individualOwner.suffix"
                                    items={Suffixes}
                                    label="Suffix"
                                    className="lh-fifth-width"
                                />
                            </div>
                            <div>
                                <FormTextBox name="individualOwner.akaName" label="A/K/A" className="lh-third-width" />
                                <FormSelect
                                    items={convertMartialStatusesToSelectList()}
                                    name="individualOwner.maritalStatusId"
                                    label="Marital Status"
                                    className="lh-third-width"
                                />
                                <FormTextBox name="individualOwner.ssnTaxId" label="SSN" className="lh-third-width" />
                            </div>
                            <div>
                                <FormTextBox
                                    style={{ width: '25%' }}
                                    name="individualOwner.spouseFirstName"
                                    label="Spouse First Name"
                                    className="lh-fourth-width"
                                />
                                <FormTextBox
                                    style={{ width: '25%' }}
                                    name="individualOwner.spouseMiddleName"
                                    label="Spouse Middle Name"
                                    className="lh-fourth-width"
                                />
                                <FormTextBox
                                    style={{ width: '25%' }}
                                    name="individualOwner.spouseLastName"
                                    label="Spouse Last Name"
                                    className="lh-fourth-width"
                                />
                                <FormTextBox
                                    style={{ width: '25%' }}
                                    name="individualOwner.spouseAkaName"
                                    label="Spouse A/K/A"
                                    className="lh-third-width"
                                />
                            </div>
                            <div>
                                <FormTextBox
                                    name="individualOwner.address.addressLine1"
                                    label="Address Line 1"
                                    className="lh-half-width"
                                />
                                <FormTextBox name="individualOwner.address.addressLine2" label="Address Line 2" className="lh-half-width" />
                            </div>
                            <div>
                                <FormTextBox
                                    name="individualOwner.address.zipCode"
                                    label="Zip Code"
                                    onChange={(e) =>
                                        ZipCodeUtil.getCityState('individualOwner', e.target.value, this.props.form, this.props.getCityState)
                                    }
                                    className="lh-third-width"
                                />
                                <FormTextBox name="individualOwner.address.city" label="City" className="lh-third-width" />
                                <FormSelect
                                    name="individualOwner.address.state.id"
                                    label="State"
                                    items={selectStates}
                                    className="lh-third-width"
                                />
                            </div>
                            <div>
                                <FormTextBox
                                    name="individualOwner.AddressInformationDate"
                                    label="Date of Address Information"
                                    className="lh-third-width"
                                    type={FormTextBoxDataType.Date}
                                />
                                <FormTextBox name="individualOwner.email" label="Email" className="lh-third-width" />
                            </div>
                            <MultiplePhoneNumber
                                phoneNumberTypes={this.props.phoneNumberTypes}
                                baseFieldName="individualOwner"
                                form={this.props.form}
                            />
                            <div className="button-row">
                                <Button text="Previous" onClick={this.props.prev} />
                                <Button text="Next" onClick={this.props.next} intent="primary" />
                            </div>
                        </div>
                    </>
                )}

                {PropertyUtil.SafeGet(() => this.props.selectedOwnerType) === OwnerType.Trust && (
                    <>
                        <div className="selected-owner-type">
                            <div>
                                <FormTextBox name="ownerTrust.trustName" label="Trust Name" className="lh-third-width" isRequired={true} />
                                <FormTextBox name="ownerTrust.trustees" label="Trustees" className="lh-third-width" isRequired={true} />
                                <FormTextBox name="ownerTrust.ssnTaxId" label="Tax Id" className="lh-third-width" />
                            </div>

                            <div>Contact Person</div>
                            <div>
                                <FormSelect name="ownerTrust.contactPersonPrefix" items={Prefixes} label="Prefix" className="lh-fifth-width" />
                                <FormTextBox
                                    name="ownerTrust.contactPersonFirstName"
                                    label="First Name"
                                    className="lh-fifth-width"
                                    isRequired={true}
                                />
                                <FormTextBox name="ownerTrust.contactPersonMiddleName" label="Middle Name" className="lh-fifth-width" />
                                <FormTextBox name="ownerTrust.contactPersonLastName" label="Last Name" className="lh-fifth-width" isRequired={true} />
                                <FormSelect name="ownerTrust.contactPersonSuffix" items={Suffixes} label="Suffix" className="lh-fifth-width" />
                            </div>
                            <div>
                                <FormTextBox name="ownerTrust.contactPersonEmail" label="Email" className="lh-half-width" />
                            </div>

                            <div>Address:</div>
                            <FormTextBox name="ownerTrust.address.addressLine1" label="Address Line 1" />
                            <FormTextBox name="ownerTrust.address.addressLine2" label="Address Line 2" />
                            <div>
                                <FormTextBox
                                    name="ownerTrust.address.zipCode"
                                    label="Zip Code"
                                    onChange={(e) => ZipCodeUtil.getCityState('ownerTrust', e.target.value, this.props.form, this.props.getCityState)}
                                    className="lh-third-width"
                                />
                                <FormTextBox name="ownerTrust.address.city" label="City" className="lh-third-width" />
                                <FormSelect
                                    name="ownerTrust.address.state.id"
                                    label="State"
                                    items={selectStates}
                                    className="lh-third-width"
                                />
                            </div>
                            <MultiplePhoneNumber phoneNumberTypes={this.props.phoneNumberTypes} baseFieldName="ownerTrust" form={this.props.form} />
                            <div className="button-row">
                                <Button text="Previous" onClick={this.props.prev} />
                                <Button text="Next" onClick={this.props.next} intent="primary" />
                            </div>
                        </div>
                    </>
                )}

                {PropertyUtil.SafeGet(() => this.props.selectedOwnerType) === OwnerType.Business && (
                    <>
                        <div className="selected-owner-type">
                            <div>
                                <FormTextBox name="businessOwner.name" label="Business Name" className="lh-half-width" isRequired={true} />
                                <FormTextBox name="businessOwner.ssnTaxId" label="Tax Id" className="lh-half-width" />
                            </div>

                            <div>Contact Person</div>
                            <div>
                                <FormSelect name="businessOwner.contactPersonPrefix" items={Prefixes} label="Prefix" className="lh-fifth-width" />
                                <FormTextBox
                                    name="businessOwner.contactPersonFirstName"
                                    label="First Name"
                                    className="lh-fifth-width"
                                    isRequired={true}
                                />
                                <FormTextBox name="businessOwner.contactPersonMiddleName" label="Middle Name" className="lh-fifth-width" />
                                <FormTextBox
                                    name="businessOwner.contactPersonLastName"
                                    label="Last Name"
                                    className="lh-fifth-width"
                                    isRequired={true}
                                />
                                <FormSelect name="businessOwner.contactPersonSuffix" items={Suffixes} label="Suffix" className="lh-fifth-width" />
                            </div>
                            <div>
                                <FormTextBox name="businessOwner.contactPersonEmail" label="Email" className="lh-fifth-width" />
                            </div>

                            <div>
                                <FormTextBox name="businessOwner.contactPersonTitle" label="Title" className="lh-fifth-width" />
                            </div>

                            <div>Address:</div>
                            <div>
                                <FormTextBox name="businessOwner.address.addressLine1" label="Address Line 1" />
                                <FormTextBox name="businessOwner.address.addressLine2" label="Address Line 2" />
                            </div>
                            <div>
                                <FormTextBox
                                    name="businessOwner.address.zipCode"
                                    label="Zip Code"
                                    onChange={(e) =>
                                        ZipCodeUtil.getCityState('businessOwner', e.target.value, this.props.form, this.props.getCityState)
                                    }
                                    className="lh-third-width"
                                />
                                <FormTextBox name="businessOwner.address.city" label="City" className="lh-third-width" />
                                <FormSelect
                                    name="businessOwner.address.state.id"
                                    label="State"
                                    items={selectStates}
                                    className="lh-third-width"
                                />
                            </div>
                            <MultiplePhoneNumber
                                phoneNumberTypes={this.props.phoneNumberTypes}
                                baseFieldName="businessOwner"
                                form={this.props.form}
                            />
                            <div className="button-row">
                                <Button text="Previous" onClick={this.props.prev} />
                                <Button text="Next" onClick={this.props.next} intent="primary" />
                            </div>
                        </div>
                    </>
                )}

                {PropertyUtil.SafeGet(() => this.props.selectedOwnerType) === OwnerType.GovBLM && (
                    <>
                        <div className="selected-owner-type">
                            <div>
                                <FormTextBox name="bolmOwner.regionalOffice" label="Regional Office" className="lh-half-width" isRequired={true} />
                                <FormTextBox name="bolmOwner.ssnTaxId" label="Tax Id" className="lh-fourth-width"/>
                                <FormSelect name="bolmOwner.stateId" label="State" items={selectStates} className="lh-fourth-width" />
                            </div>

                            <div>Contact Person</div>
                            <div>
                                <FormSelect name="bolmOwner.contactPersonPrefix" items={Prefixes} label="Prefix" className="lh-fifth-width" />
                                <FormTextBox
                                    name="bolmOwner.contactPersonFirstName"
                                    label="First Name"
                                    className="lh-fifth-width"
                                    isRequired={true}
                                />
                                <FormTextBox name="bolmOwner.contactPersonMiddleName" label="Middle Name" className="lh-fifth-width" />
                                <FormTextBox name="bolmOwner.contactPersonLastName" label="Last Name" className="lh-fifth-width" isRequired={true} />
                                <FormSelect name="bolmOwner.contactPersonSuffix" items={Suffixes} label="Suffix" className="lh-fifth-width" />
                            </div>
                            <div>
                                <FormTextBox name="bolmOwner.email" label="Email" className="lh-fifth-width" />
                            </div>

                            <div>Address:</div>
                            <div>
                                <FormTextBox name="bolmOwner.address.addressLine1" label="Address Line 1" />
                                <FormTextBox name="bolmOwner.address.addressLine2" label="Address Line 2" />
                            </div>
                            <div>
                                <FormTextBox
                                    name="bolmOwner.address.zipCode"
                                    label="Zip Code"
                                    onChange={(e) => ZipCodeUtil.getCityState('bolmOwner', e.target.value, this.props.form, this.props.getCityState)}
                                    className="lh-third-width"
                                />
                                <FormTextBox name="bolmOwner.address.city" label="City" className="lh-third-width" />
                                <FormSelect
                                    name="bolmOwner.address.state.id"
                                    label="State"
                                    items={selectStates}
                                    className="lh-third-width"
                                />
                            </div>
                            <MultiplePhoneNumber phoneNumberTypes={this.props.phoneNumberTypes} baseFieldName="bolmOwner" form={this.props.form} />
                            <div className="button-row">
                                <Button text="Previous" onClick={this.props.prev} />
                                <Button text="Next" onClick={this.props.next} intent="primary" />
                            </div>
                        </div>
                    </>
                )}

                {PropertyUtil.SafeGet(() => this.props.selectedOwnerType) === OwnerType.GovRAL && (
                    <>
                        <div className="selected-owner-type">
                            <div>
                                <FormSelect name="ralOwner.stateId" label="State" items={selectStates} className="lh-fifth-width" isRequired={true} />
                            </div>
                            <div>
                                <FormSelect
                                    name="ralOwner.surfaceOwnerAgentPrefix"
                                    items={Prefixes}
                                    label="Surface Owner Prefix"
                                    className="lh-fifth-width"
                                />
                                <FormTextBox
                                    name="ralOwner.surfaceOwnerAgentFirstName"
                                    label="Surface Owner Agent First Name"
                                    className="lh-half-width"
                                    isRequired={true}
                                />
                            </div>
                            <div>
                                <FormTextBox
                                    name="ralOwner.surfaceOwnerAgentMiddleName"
                                    label="Surface Owner Agent Middle Name"
                                    className="lh-half-width"
                                />
                                <FormTextBox
                                    name="ralOwner.surfaceOwnerAgentLastName"
                                    label="Surface Owner Agent Last Name"
                                    className="lh-half-width"
                                    isRequired={true}
                                />
                            </div>
                            <div>
                                <FormSelect
                                    name="ralOwner.surfaceOwnerAgentSuffix"
                                    items={Suffixes}
                                    label="Surface Owner Suffix"
                                    className="lh-fifth-width"
                                />
                                <FormTextBox
                                    name="ralOwner.ssnTaxId"
                                    label="Tax Id"
                                    className="lh-third-width"
                                />
                            </div>

                            <div>
                                <FormTextBox name="ralOwner.spouseFirstName" label="Spouse First Name" className="lh-third-width" />
                                <FormTextBox name="ralOwner.spouseLastName" label="Spouse Last Name" className="lh-third-width" />
                            </div>

                            <div>
                                <FormTextBox
                                    name="ralOwner.address.addressLine1"
                                    label="Address Line 1"
                                    className="lh-half-width"
                                />
                                <FormTextBox name="ralOwner.address.addressLine2" label="Address Line 2" className="lh-half-width" />
                            </div>

                            <div>
                                <FormTextBox
                                    name="ralOwner.address.zipCode"
                                    label="Zip Code"
                                    onChange={(e) => ZipCodeUtil.getCityState('ralOwner', e.target.value, this.props.form, this.props.getCityState)}
                                    className="lh-third-width"
                                />
                                <FormTextBox name="ralOwner.address.city" label="City" className="lh-third-width" />
                                <FormSelect
                                    name="ralOwner.address.state.id"
                                    label="State"
                                    items={selectStates}
                                    className="lh-third-width"
                                />
                            </div>
                            <div>
                                <FormTextBox name="ralOwner.email" label="Email" className="lh-third-width" />
                            </div>
                            <MultiplePhoneNumber phoneNumberTypes={this.props.phoneNumberTypes} baseFieldName="ralOwner" form={this.props.form} />
                            <div className="button-row">
                                <Button text="Previous" onClick={this.props.prev} />
                                <Button text="Next" onClick={this.props.next} intent="primary" />
                            </div>
                        </div>
                    </>
                )}

                {PropertyUtil.SafeGet(() => this.props.selectedOwnerType) === OwnerType.GovSTATE && (
                    <>
                        <div className="selected-owner-type">
                            <div>
                                <FormSelect
                                    name="stateLandOwner.stateId"
                                    label="State"
                                    items={selectStates}
                                    className="lh-third-width"
                                />
                                <FormTextBox name="stateLandOwner.agencyName" label="Agency Name" className="lh-third-width" isRequired={true} />
                                <FormTextBox name="stateLandOwner.ssnTaxId" label="Tax Id" className="lh-third-width" />
                            </div>

                            <div>Contact Person</div>
                            <div>
                                <FormSelect name="stateLandOwner.contactPersonPrefix" items={Prefixes} label="Prefix" className="lh-fifth-width" />
                                <FormTextBox
                                    name="stateLandOwner.contactPersonFirstName"
                                    label="First Name"
                                    className="lh-fifth-width"
                                    isRequired={true}
                                />
                                <FormTextBox name="stateLandOwner.contactPersonMiddleName" label="Middle Name" className="lh-fifth-width" />
                                <FormTextBox
                                    name="stateLandOwner.contactPersonLastName"
                                    label="Last Name"
                                    className="lh-fifth-width"
                                    isRequired={true}
                                />
                                <FormSelect name="stateLandOwner.contactPersonSuffix" items={Suffixes} label="Suffix" className="lh-fifth-width" />
                            </div>

                            <div>
                                <FormTextBox
                                    name="stateLandOwner.address.addressLine1"
                                    label="Address Line 1"
                                    className="lh-half-width"
                                />
                                <FormTextBox name="stateLandOwner.address.addressLine2" label="Address Line 2" className="lh-half-width" />
                            </div>

                            <div>
                                <FormTextBox
                                    name="stateLandOwner.address.zipCode"
                                    label="Zip Code"
                                    onChange={(e) =>
                                        ZipCodeUtil.getCityState('stateLandOwner', e.target.value, this.props.form, this.props.getCityState)
                                    }
                                    className="lh-third-width"
                                />
                                <FormTextBox name="stateLandOwner.address.city" label="City" className="lh-third-width" />
                                <FormSelect
                                    name="stateLandOwner.address.state.id"
                                    label="State"
                                    items={selectStates}
                                    className="lh-third-width"
                                />
                            </div>
                            <div>
                                <FormTextBox name="stateLandOwner.email" label="Email" className="lh-third-width" />
                            </div>
                            <MultiplePhoneNumber
                                phoneNumberTypes={this.props.phoneNumberTypes}
                                baseFieldName="stateLandOwner"
                                form={this.props.form}
                            />
                            <div className="button-row">
                                <Button text="Previous" onClick={this.props.prev} />
                                <Button text="Next" onClick={this.props.next} intent="primary" />
                            </div>
                        </div>
                    </>
                )}

                {PropertyUtil.SafeGet(() => this.props.selectedOwnerType) === OwnerType.JointTenant && (
                    <>
                        <div className="selected-owner-type">
                            <div>
                                <FormTextBox
                                    name="ownerJointTenant.name"
                                    label="Joint Tenant Owner Group"
                                    className="lh-four-fifths-width"
                                    isRequired={true}
                                />
                                <FormTextBox name="ownerJointTenant.ssnTaxId" label="SSN/Tax Id" className="lh-fifth-width" />
                                <div>
                                    <FormTextBox
                                        name="ownerJointTenant.addressLine1"
                                        label="Address Line 1"
                                        className="lh-half-width"
                                    />
                                    <FormTextBox name="ownerJointTenant.addressLine2" label="Address Line 2" className="lh-half-width" />
                                </div>

                                <div>
                                    <FormTextBox
                                        name="ownerJointTenant.zipCode"
                                        label="Zip Code"
                                        className="lh-eighth-width"
                                        onChange={(e) =>
                                            ZipCodeUtil.getCityState('ownerJointTenant', e.target.value, this.props.form, this.props.getCityState)
                                        }
                                    />
                                    <FormTextBox name="ownerJointTenant.city" label="City" className="lh-eighth-width" />

                                    <FormSelect
                                        name="ownerJointTenant.state"
                                        label="State"
                                        items={selectJTStates}
                                        className="lh-third-width"
                                    />

                                    <FormTextBox name="ownerJointTenant.phoneNumber" label="Phone Number" className="lh-eighth-width" />
                                    <FormTextBox name="ownerJointTenant.email" label="Email" className="lh-eighth-width" />
                                </div>
                            </div>
                            <div>
                                {this.state.tenantOwners.length > 0 && (
                                    <>
                                        <div style={{ fontSize: '2rem', marginBottom: '1rem' }}>Tenant Owners</div>
                                        {this.jointTenantOwners()}
                                    </>
                                )}
                            </div>
                            <div style={{ marginTop: '1rem' }}>
                                <Button text="Add More Information" onClick={this.addJointTenantOwner} />
                            </div>

                            <div className="button-row" style={{ marginTop: '2rem' }}>
                                <Button text="Previous" onClick={this.props.prev} />
                                <Button text="Next" onClick={this.props.next} intent="primary" />
                            </div>
                        </div>
                    </>
                )}
            </>
        );
    }
}

export default OwnerTypesForms;



// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/OwnerTypesForms.tsx